import __ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import accountManagement from "../../../../apis/accountManagement";
import siswaApi from "../../../../apis/utilManagement";
import { CONFIG, CONFIG_UTIL } from "../../../../config";
import Loader from "../../../Loader";
import LoaderModal from "../../../modal/LoaderModal";
import Navbar from "../../navbar/Navbar";
import Sidebar from "../../sidebar/Sidebar";
import env from "react-dotenv";

import KelasParalelSearch from "../../../../entity/KelasParalelSearch";
import KelasSearch from "../../../../entity/KelasSearch";

import { Button, Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import DropdownKelas from "../masterDropDown/DropdownKelas";
import DropdownKelasParalel from "../masterDropDown/DropdownKelasParalel";
import DropdownTahunAjaran from "../masterDropDown/DropdownTahunAjaran";
import FormMgtNilai from "./FormMgtNilai";
import FormReporting from "./FormReporting";
import { Grid } from "@material-ui/core";

class MgtNilai extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            alertShow: false,
            isListSiswa: true,
            isMgtNilai: false,
            isReporting: true,
            siswa: [],
            kelas: [],
            kelasParalel: [],
            ta: [],
            idKelas: null,
            idKelasParalel: null,
            kodeTa: null,
            dataSiswa: {},
            title: "Management Nilai Raport Siswa",
            semester: [],
            idSnmptnSemester: null,
            listMapel: [],
            urlSiswaFe: process.env.REACT_APP_URL_SISWA_FE,
            setModalMapel: false,
            setModalImport: false,
            importFile: null,
        };
    }

    async componentDidMount() {
        document.title = "MGT Nilai SNMPTN";
        this.setState({
            isFetching: true,
        });
        await this.props.cekCookies();

        if (this.props.account.isSnmptn === 0) {
            window.location.assign("/dashboard");
        }

        if (!__.isEmpty(this.props.account)) {
            this.fetchTa();
            this.getKelas();
            this.fetchListMapel();
        }

        this.setState({
            isFetching: false,
        });
    }

    handleBack = async () => {
        this.setState({
            isListSiswa: true,
            isMgtNilai: false,
            isReporting: false,
            title: "Management Nilai Raport Siswa",
        });
    };

    handleOffFeching = async () => {
        this.setState({
            isFetching: false,
            isLoading: false,
        });
    };

    handleOnFeching = async () => {
        this.setState({ isFetching: true });
    };

    handleInputNumber = async () => {
        console.log("====================================");
        console.log("input number");
        console.log("====================================");
    };

    handleChecklistAll = async () => {
        console.log("====================================");
        console.log("checklist all");
        console.log("====================================");
    };

    fetchTa = async () => {
        //fetch tahun ajaran dulu
        const resTa = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN).catch(function (error) {});
        if (resTa) {
            if (resTa.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    ta: resTa.data.data,
                    idKelas: null,
                    idKelasParalel: null,
                });
            }
        }

        resTa.data.data.map((val) => {
            if (val.status === "1") {
                this.setState({ kodeTa: val.kodeTahunAjaran });
            }
        });
    };

    fetchListMapel = async () => {
        //fetch tahun ajaran dulu
        const resListMapel = await accountManagement.get(CONFIG.GET_LIST_MAPEL).catch(function (error) {});
        if (resListMapel) {
            if (resListMapel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    listMapel: resListMapel.data.data.data,
                });
            }
        }
        console.log("====================================");
        console.log("List Mapel => ", resListMapel);
        console.log("====================================");
    };

    handleOnChangeTa = async (ta) => {
        this.setState({
            kodeTa: ta.target.value,
            idKelas: "",
            idKelasParalel: "",
        });
    };

    getKelas = async () => {
        this.setState({
            isFetching: true,
        });

        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function (error) {});
        if (resSekolah) {
            if (resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    sekolah: resSekolah.data.data,
                });
            }
        }

        const res = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, { KelasSearch, ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah }).catch(function (error) {
            console.error("Error getKelas", error);
        });
        console.info("Result getKelas", res);

        if (res) {
            if (res.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelas: res.data.data,
                });
            } else {
                this.setState({
                    resMessage: res.data.errorSchema.errorMessage,
                });
            }

            this.setState({
                isFetching: false,
            });
        }
    };

    handleOnChangeKelas = async (idKelas) => {
        console.clear();
        this.setState({
            idKelas: idKelas.target.value,
            idKelasParalel: "",
        });

        this.setState({
            isLoading: true,
        });
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL, { KelasParalelSearch, ["idKelas"]: idKelas.target.value, ["idSekolah"]: this.props.account.idSekolah }).catch(function (error) {});

        if (response) {
            if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    kelasParalel: response.data.data,
                });
            }

            this.setState({
                isLoading: false,
            });
        }
    };

    handleOnChangeKelasParalel = async (kp) => {
        console.clear();
        this.setState({
            idKelasParalel: kp.target.value,
            isLoading: true,
            siswa: [],
        });
        this.fetchSiswaKelas(kp.target.value);
    };

    handleOnChangeSemester = async (semester) => {
        console.log("====================================");
        console.log("semester", semester.target.value);
        console.log("====================================");
        this.setState({
            idSnmptnSemester: semester.target.value,
        });
    };

    doHandleOnClickSemester = async (semester) => {
        this.setState({
            isLoading: true,
        });
        const setSemester = await accountManagement
            .post(CONFIG.SET_SNMPTN, {
                idKelas: this.state.idKelas,
                idKelasParalel: this.state.idKelasParalel,
                kodeTahunAjaran: this.state.kodeTa,
                idSnmptnSemester: this.state.idSnmptnSemester,
            })
            .catch(function (error) {});
        console.log(setSemester);

        this.fetchSiswaKelas(this.state.idKelasParalel);
        this.setState({
            isLoading: false,
        });
    };

    fetchSiswaKelas = async (kp) => {
        if (kp === "") kp = this.state.idKelasParalel;

        const resSiswaKelasParelel = await accountManagement
            .post(CONFIG.SNMPTN_FETCH_SISWA_SEMESTER, {
                idKelas: this.state.idKelas,
                idKelasParalel: kp,
                idSekolah: this.props.account.idSekolah,
                kodeTahunAjaran: this.state.kodeTa,
            })
            .catch(function (error) {});
        console.log(resSiswaKelasParelel.data.data);

        if (resSiswaKelasParelel) {
            if (resSiswaKelasParelel.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    siswa: resSiswaKelasParelel.data.data,
                    isLoading: false,
                });
            }
        }

        const resSemester = await accountManagement.get(CONFIG.GET_LIST_SEMESTER + this.state.idKelasParalel).catch(function (error) {});
        if (resSemester) {
            if (resSemester.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                this.setState({
                    semester: resSemester.data.data.data,
                });
            }
        }
        console.log("====================================");
        console.log(resSemester);
        console.log("====================================");
        // console.log("semester => ", resSemester, "idKelasParalel => ", this.state.idKelasParalel);

        // set cbx siswa sekkk.................
        // if(!__.isEmpty(resSiswaKelasParelel.data.data)){
        //     resSiswaKelasParelel.data.data.map((val, i) => {
        //         this.setState({
        //             ['cbx'+val.idSiswa] : val.isInsertSiswa === '0' ? '' : ''
        //         })
        //     })
        // }

        this.handleOffFeching();
    };

    renderSiswa() {
        if (!__.isEmpty(this.state.siswa)) {
            return (
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Username</th>
                            <th>Nama Siswa</th>
                            <th>Email</th>
                            <th>Semester</th>
                            <th>Input Siswa</th>
                            <th>Akses Report</th>
                            <th>#</th>
                        </tr>
                    </thead>
                    <tbody>{this.renderChildSiswa()}</tbody>
                </table>
            );
        }
    }

    renderChildSiswa() {
        var n = 1;
        return this.state.siswa.map((val, j) => {
            const found = this.state.siswa.find((e) => parseInt(e) === val.isInsertSiswa);

            return (
                <tr key={j}>
                    <td>{n++}</td>
                    <td>{val.usernameSiswa}</td>
                    <td>{val.namaSiswa}</td>
                    <td>{val.emailSiswa}</td>
                    <td>{__.isEmpty(val.semester) ? "-" : val.semester}</td>
                    <td>
                        {val.isInsertSiswa === "0" || __.isEmpty(val.isInsertSiswa) ? (
                            <button className="btn btn-outline-danger" title="Buka Akses.." onClick={() => this.doHandleBukaTutup(1, val.idSiswa)}>
                                {" "}
                                <li className="fa fa-times"></li>
                            </button>
                        ) : (
                            <button className="btn btn-outline-primary" title="Tutup Akses.." onClick={() => this.doHandleBukaTutup(0, val.idSiswa)}>
                                {" "}
                                <li className="fa fa-check"></li>
                            </button>
                        )}
                    </td>
                    <td>
                        {val.isOpenReportSiswa === "0" || __.isEmpty(val.isOpenReportSiswa) ? (
                            <button className="btn btn-outline-danger" title="Buka Akses.." onClick={() => this.doHandleBukaTutupReport(1, val.idSiswa)}>
                                {" "}
                                <li className="fa fa-times"></li>
                            </button>
                        ) : (
                            <button className="btn btn-outline-success" title="Tutup Akses.." onClick={() => this.doHandleBukaTutupReport(0, val.idSiswa)}>
                                {" "}
                                <li className="fa fa-check"></li>
                            </button>
                        )}
                    </td>
                    <td>
                        <button className="btn btn-info" title="Edit Nilai" onClick={() => this.pidahPage("mgtNilai", val.idSiswa)}>
                            <li className="fa fa-pencil"></li>
                        </button>

                        {__.isEmpty(val.semester) ? (
                            <a className="btn btn-primary  " title="Belum Input nilai" disabled>
                                <li className="fa fa-eye"></li>
                            </a>
                        ) : (
                            <a className="btn btn-primary  " title="Report Nilai SNMPTN" href={this.state.urlSiswaFe + "/snmptn/pageReportSnmptnNew.html?" + val.idSiswa} target="_BLANK">
                                <li className="fa fa-eye"></li>
                            </a>
                        )}
                    </td>
                </tr>
            );
        });
    }

    doHandleBukaTutup = async (stt, idSiswa) => {
        this.setState({
            isLoading: true,
        });
        const handleBukaTutup = await accountManagement
            .post(CONFIG.SNMPTN_CHANGE_BUKA_TUTUP, {
                status: stt,
                idSiswa: idSiswa,
                idKelasParalel: "",
            })
            .catch(function (error) {
                console.error(error);
            });

        this.fetchSiswaKelas(this.state.idKelasParalel);
    };

    doHandleBukaTutupSemua = async (stt) => {
        this.setState({
            isLoading: true,
        });
        const res = await accountManagement
            .post(CONFIG.SNMPTN_CHANGE_BUKA_TUTUP, {
                status: stt,
                idSiswa: "",
                idKelasParalel: this.state.idKelasParalel,
            })
            .catch(function (error) {
                console.error(error);
            });

        console.log("====================================");
        console.log("Buka Tutup Semua => ", res);
        console.log("====================================");
        this.fetchSiswaKelas(this.state.idKelasParalel);
    };

    doHandleBukaTutupReport = async (stt, idSiswa) => {
        this.setState({
            isLoading: true,
        });
        await accountManagement
            .post(CONFIG.SNMPTN_CHANGE_BUKA_TUTUP_REPORT, {
                status: stt,
                idSiswa: idSiswa,
                idKelasParalel: "",
            })
            .catch(function (error) {
                console.error(error);
            });
        await siswaApi.post(CONFIG_UTIL.CACHE_REPORT_SISWA + idSiswa)
            .catch(function (error) {
                console.error(error);
            });

        this.fetchSiswaKelas(this.state.idKelasParalel);
    };

    doHandleBukaTutupSemuaReport = async (stt) => {
        this.setState({
            isLoading: true,
        });
        const res = await accountManagement
            .post(CONFIG.SNMPTN_CHANGE_BUKA_TUTUP_REPORT, {
                status: stt,
                idSiswa: "",
                idKelasParalel: this.state.idKelasParalel,
            })
            .catch(function (error) {
                console.error(error);
            });

        console.log("====================================");
        console.log("Buka Tutup Semua => ", res);
        console.log("====================================");
        this.fetchSiswaKelas(this.state.idKelasParalel);
    };

    doHandleSelectMapel = async (isActive, idSnmptnLintasMinatSekolah, idMataPelajaran) => {
        this.setState({
            isLoading: true,
        });
        const res = await accountManagement
            .post(CONFIG.SET_LIST_MAPEL, {
                idSnmptnLintasMinatSekolah: idSnmptnLintasMinatSekolah,
                idMataPelajaran: idMataPelajaran,
                isActive: isActive,
            })
            .catch(function (error) {
                console.error(error);
            });

        console.log("====================================");
        console.log("select mapel => ", res);
        console.log("====================================");
        this.fetchListMapel();
    };

    pidahPage = async (page, id) => {
        console.info("PAGE", page);
        this.state.siswa.map((val, j) => {
            if (id === val.idSiswa) {
                this.setState({
                    isFetching: true,
                    dataSiswa: val,
                });

                console.info("SISWA KIRIM", val);

                if (page === "mgtNilai") {
                    console.info("PAGE MGT NILAI", page);
                    this.setState({
                        isListSiswa: false,
                        isMgtNilai: true,
                        isReporting: false,
                        title: "Manajemen data " + val.namaSiswa,
                    });
                } else {
                    console.info("PAGE REPORTING", page);
                    this.setState({
                        isListSiswa: false,
                        isMgtNilai: false,
                        isReporting: true,
                        title: "Report Nilai " + val.namaSiswa,
                    });
                }
            }
        });
    };

    modalMapel() {
        return (
            <>
                {this.state.listMapel.map((val, i) => {
                    return (
                        <div className="row mb-3" key={i}>
                            <div className="col-md-9 pt-2">{val.namaMataPelajaran}</div>
                            <div className="col-md-3">
                                {val.isActive === 0 ? (
                                    <button className="btn btn-outline-danger" title="Buka Akses.." onClick={() => this.doHandleSelectMapel(1, val.idSnmptnLintasMinatSekolah, val.idMataPelajaran)}>
                                        <li className="fa fa-times"></li>
                                    </button>
                                ) : (
                                    <button className="btn btn-outline-primary" title="Tutup Akses.." onClick={() => this.doHandleSelectMapel(0, val.idSnmptnLintasMinatSekolah, val.idMataPelajaran)}>
                                        <li className="fa fa-check"></li>
                                    </button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </>
        );
    }

    onFileChange = (event) => {
        this.setState({ importFile: event.target.files[0] });
        // setimportFile(event.target.files[0]);
    };

    handleSubmitFile = async (event) => {
        this.setState({
            isFetching: true,
        });
        event.preventDefault();

        if (this.state.importFile !== "" && this.state.importFile.size < 1000000) {
            let data = new FormData();
            data.append("file", this.state.importFile);
            const response = await accountManagement.post(CONFIG.SNBP_IMPORT_NILAI + "?idKelas=" + this.state.idKelas + "&kodeTahunAjaran=" + this.state.kodeTa, data).catch(function (error) {
                console.log("====================================");
                console.log(error);
                console.log("====================================");
            });

            console.log("response submit", response);
            if (response) {
                alert("File Dokumen sukses diupload !!");
                this.handleCloseModalImport();
                document.getElementById("file").value = "";

                this.setState({
                    isFetching: false,
                });
            }
        } else {
            alert("File Dokumen harus < 1Mb ..!!");
            this.setState({
                isFetching: false,
            });
        }
    };

    openModal = () => this.setState({ setModalMapel: true });
    closeModal = () => this.setState({ setModalMapel: false });

    handleOpenModalImport = () => {
        console.log("====================================");
        console.log("open modal import");
        console.log(this.props);
        console.log(this.state.kodeTa);
        console.log(this.state.idKelasParalel);
        console.log("====================================");
        this.setState({ setModalImport: true });
    };
    handleCloseModalImport = () => {
        this.setState({ setModalImport: false });
    };

    render() {
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} />

                <div id="content" style={{ paddingBottom: "50px" }}>
                    <Navbar title={this.state.title} />
                    <div className="container-fluid">
                        {this.state.isListSiswa && (
                            <div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Tahun ajaran</label>
                                            <select className="form-control" value={this.state.kodeTa} onChange={this.handleOnChangeTa} required>
                                                <option value="" selected disabled>
                                                    ~~ Pilih Tahun Ajaran ~~
                                                </option>
                                                <DropdownTahunAjaran tahunAjaran={this.state.ta} />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Kelas Paralel</label>
                                            <select className="form-control" value={this.state.idKelas} onChange={this.handleOnChangeKelas} required>
                                                <option value="" selected disabled>
                                                    ~~ Pilih Kelas Paralel ~~
                                                </option>
                                                <DropdownKelas kelas={this.state.kelas} />
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Kelas </label>
                                            <select className="form-control" value={this.state.idKelasParalel} onChange={this.handleOnChangeKelasParalel} required>
                                                <option value="" selected disabled>
                                                    ~~ Pilih Kelas ~~
                                                </option>
                                                <DropdownKelasParalel kelasParalel={this.state.kelasParalel} />
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-3">
                                        <label>Semester</label>
                                        <select className="form-control" value={this.state.idSnmptnSemester} onChange={this.handleOnChangeSemester} required>
                                            <option value="" selected disabled>
                                                ~~ Pilih Semester ~~
                                            </option>
                                            {this.state.semester.map((val, i) => {
                                                return (
                                                    <option key={i} value={val.idSemester} selected={val.isActive > 0 ? "selected" : ""}>
                                                        {val.keterangan}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                    <div className="col-md-1 pt-4">
                                        <button className="btn btn-info btn-block" type="button" onClick={this.doHandleOnClickSemester}>
                                            Kirim
                                        </button>
                                    </div>
                                </div>
                                <div className="row" style={{ marginBottom: "20px" }}>
                                    <div className="col-md-4 pt-4">
                                        <button className="btn btn-primary mr-3" type="button" onClick={this.openModal}>
                                            Mata Pelajaran
                                        </button>
                                        <button className="btn btn-success" type="button" onClick={this.handleOpenModalImport}>
                                            Import Excel
                                        </button>
                                    </div>
                                    <div className="col-md-4 pt-4">
                                        <button className="btn btn-success mr-1" type="button" onClick={() => this.doHandleBukaTutupSemua(1)}>
                                            Buka Semua Input
                                        </button>
                                        <button className="btn btn-danger" type="button" onClick={() => this.doHandleBukaTutupSemua(0)}>
                                            Tutup Semua Input
                                        </button>
                                    </div>
                                    <div className="col-md-4 pt-4">
                                        <button className="btn btn-success mr-1" type="button" onClick={() => this.doHandleBukaTutupSemuaReport(1)}>
                                            Buka Semua Report
                                        </button>
                                        <button className="btn btn-danger" type="button" onClick={() => this.doHandleBukaTutupSemuaReport(0)}>
                                            Tutup Semua Report
                                        </button>
                                    </div>
                                </div>
                                <div className="row">{this.renderSiswa()}</div>
                            </div>
                        )}

                        {this.state.isMgtNilai && (
                            <FormMgtNilai
                                dataSiswa={this.state.dataSiswa}
                                idKelas={this.state.idKelas}
                                tahunAjaran={this.state.kodeTa}
                                handleBack={this.handleBack}
                                handleOffFeching={this.handleOffFeching}
                                handleOnFeching={this.handleOnFeching}
                                fetchSiswaKelas={this.fetchSiswaKelas}
                            />
                        )}

                        {this.state.isReporting && (
                            <FormReporting
                                dataSiswa={this.state.dataSiswa}
                                idKelas={this.state.idKelas}
                                handleBack={this.handleBack}
                                handleOffFeching={this.handleOffFeching}
                                handleOnFeching={this.handleOnFeching}
                                fetchSiswaKelas={this.fetchSiswaKelas}
                            />
                        )}

                        {this.loading()}
                    </div>
                </div>
                <Modal show={this.state.setModalMapel} onHide={this.closeModal} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">Mata Pelajaran</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.modalMapel()}</Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.closeModal}>Close</Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.setModalImport} aria-labelledby="example-custom-modal-styling-title" size="lg" backdrop="static" keyboard={false}>
                    <Modal.Header>
                        <Modal.Title>Import Program Studi</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={this.handleSubmitFile}>
                            <Row style={{ marginBottom: 40 }}>
                                <Col>
                                    <input type="file" className="form-control" required onChange={this.onFileChange} id="file" accept=".xlsx" />
                                </Col>
                                <Col>
                                    <h5>Prosedur Upload Prodi :</h5>
                                    <ol>
                                        <li>Download format dokumen (.xlsx)&nbsp;</li>
                                        <li>Isi dokumen berdasarkan format yang sudah ditentukan</li>
                                        <li>
                                            Format dokumen wajib &nbsp;
                                            <span class="text-danger">
                                                <strong>*</strong>
                                            </span>
                                            <strong>.xlsx</strong>
                                            <span class="text-danger">
                                                <strong>*</strong>
                                            </span>
                                        </li>
                                        <li>
                                            Prodi Akan di update berdasarkan <strong>KODE PRODI</strong> yang telah tersedia di system,
                                        </li>
                                        <li>KODE PRODI di sistem yang tidak sesuai dengan file upload akan otomatis terhapus</li>
                                        <li>PASTIKAN file yang akan di upload sudah sesuai dengan data terbaru.</li>
                                        <br />
                                        <a
                                            class="btn btn-info"
                                            target={"_blank"}
                                            href={
                                                env.REACT_APP_URL_PSEP_BE +
                                                "/snmptn/generate_excell_input_nilai?idKelas=" +
                                                this.state.idKelas +
                                                "&idKelasPararel=" +
                                                this.state.idKelasParalel +
                                                "&kodeTahunAjaran=" +
                                                this.state.kodeTa +
                                                "&idSekolah=" +
                                                this.props.account.idSekolah
                                            }
                                        >
                                            <li className="fa fa-download"> Download</li>
                                        </a>
                                    </ol>
                                </Col>
                            </Row>
                            <Grid item xs={12}>
                                <Button variant="outlined" color="secondary" style={{ float: "left" }} onClick={this.handleCloseModalImport}>
                                    <li className="fa fa-close"> Batal</li>
                                </Button>
                                <Button variant="outlined" color="primary" type="submit" style={{ float: "right" }}>
                                    <li className="fa fa-save"> Simpan</li>
                                </Button>
                            </Grid>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    loading = () => {
        if (this.state.isLoading) {
            return <Loader />;
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(MgtNilai);
